import React from 'react'
import PropTypes from 'prop-types'
import RangeSlider from './'

export default class RangeSliderWithContext extends React.Component {
  static propTypes = {
    min: RangeSlider.propTypes.min,
    max: RangeSlider.propTypes.max,
    values: RangeSlider.propTypes.values,
    chartData: RangeSlider.propTypes.chartData,
    dataKey: RangeSlider.propTypes.dataKey,
    xAxisKey: RangeSlider.propTypes.xAxisKey,
    onSelect: RangeSlider.propTypes.onSelect,
    formatValue: RangeSlider.propTypes.formatValue,
    step: RangeSlider.propTypes.step,
    limit: RangeSlider.propTypes.limit,
    disabled: RangeSlider.propTypes.disabled,
    tooltip: PropTypes.func
  }

  static contextTypes = {
    containerWidth: PropTypes.number
  }

  render() {
    const {
      min, max,
      values,
      chartData,
      dataKey,
      xAxisKey,
      step,
      onSelect,
      formatValue,
      limit,
      disabled,
      tooltip
    } = this.props
    const {containerWidth} = this.context

    return (
      <RangeSlider
        width={containerWidth}
        min={min}
        max={max}
        values={values}
        chartData={chartData}
        dataKey={dataKey}
        xAxisKey={xAxisKey}
        step={step}
        onSelect={onSelect}
        formatValue={formatValue}
        limit={limit}
        disabled={disabled}
        tooltip={tooltip}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/RangeSlider/RangeSliderWithContext.js